import Nullstack from 'nullstack';
export default function IconDashboard({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-dashboard",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "12",
    cy: "13",
    r: "2"
  }), "   ", Nullstack.element("line", {
    x1: "13.45",
    y1: "11.55",
    x2: "15.5",
    y2: "9.5"
  }), "   ", Nullstack.element("path", {
    d: "M6.4 20a9 9 0 1 1 11.2 0z"
  }), " ");
}